import { fromJS, getIn, Record } from 'immutable';

import {
  START_LOADING,
  STOP_LOADING,
  CLEAR_NOTIFICATIONS,
  CREATE_VIEW_SUCCESS,
  CREATE_VIEW_FAIL,
  UPDATE_VIEW_SUCCESS,
  UPDATE_VIEW_FAIL,
  DELETE_VIEW_SUCCESS,
  DELETE_VIEW_FAIL,
  GET_RECURRING_EMAILS_SUCCESS,
  GET_RECURRING_EMAILS_FAIL,
  GET_USER_VIEWS_SUCCESS,
  CREATE_RECURRING_EMAIL_SUCCESS,
  CREATE_RECURRING_EMAIL_FAIL,
  UPDATE_RECURRING_EMAIL_SUCCESS,
  UPDATE_RECURRING_EMAIL_FAIL,
  DELETE_RECURRING_EMAIL_SUCCESS,
  DELETE_RECURRING_EMAIL_FAIL,
} from './actions';

import { GENERIC_ERROR } from 'constants/errors.constants';

export const makeFilterRecord = Record({
  comparator: undefined,
  field: undefined,
  value: undefined,
});

const initialState = fromJS({
  emailReports: [],
  loading: false,
  errors: {},
  notifications: {},
  reportErrors: {},
});

function viewsServiceReducer(state = initialState, action) {
  switch (action.type) {
    case START_LOADING:
      // @ts-expect-error Argument of type 'boolean' is not assignable to parameter of type 'Map<"valueOf", Map<never, never>> | Map<"valueOf", Map<never, never>> | List<any> | Map<never, never> | Map<never, never> | Map<never, never>'.
      return state.set('loading', true);
    case STOP_LOADING:
      // @ts-expect-error Argument of type 'boolean' is not assignable to parameter of type 'Map<"valueOf", Map<never, never>> | Map<"valueOf", Map<never, never>> | List<any> | Map<never, never> | Map<never, never> | Map<never, never>'.
      return state.set('loading', false);
    case CLEAR_NOTIFICATIONS:
      return state.set('notifications', fromJS({})).set('errors', fromJS({}));
    case CREATE_VIEW_SUCCESS:
    case UPDATE_VIEW_SUCCESS:
    case DELETE_VIEW_SUCCESS:
    case GET_USER_VIEWS_SUCCESS:
      // @ts-expect-error Argument of type 'boolean' is not assignable to parameter of type 'Map<"valueOf", Map<never, never>> | Map<"valueOf", Map<never, never>> | List<any> | Map<never, never> | Map<never, never> | Map<never, never>'.
      return state.set('errors', fromJS({})).set('loading', false);
    case GET_RECURRING_EMAILS_SUCCESS:
      return (
        state
          .set('emailReports', fromJS(action.payload.recurringEmails))
          // @ts-expect-error Argument of type 'boolean' is not assignable to parameter of type 'Map<"valueOf", Map<never, never>> | Map<"valueOf", Map<never, never>> | List<any> | Map<never, never> | Map<never, never> | Map<never, never>'.
          .set('loading', false)
          .set('errors', fromJS({}))
      );
    case CREATE_RECURRING_EMAIL_SUCCESS:
      // @ts-expect-error Argument of type 'boolean' is not assignable to parameter of type 'Map<"valueOf", Map<never, never>> | Map<"valueOf", Map<never, never>> | List<any> | Map<never, never> | Map<never, never> | Map<never, never>'.
      return state.set('reportErrors', fromJS({})).set('loading', false);
    case UPDATE_RECURRING_EMAIL_SUCCESS: {
      const index = state
        .get('emailReports')
        // @ts-expect-error Property 'findIndex' does not exist on type 'Map<"valueOf", Map<never, never>> | Map<"valueOf", Map<never, never>> | List<any> | Map<never, never> | Map<never, never> | Map<never, never>'.
        .findIndex((report) => report.get('id') === action.payload.recurringEmail.id);
      const updatedReport = fromJS(action.payload.recurringEmail);

      return (
        state
          // @ts-expect-error Argument of type 'any' is not assignable to parameter of type 'never'.
          .update('emailReports', (report) => report.set(index, updatedReport))
          // @ts-expect-error Argument of type 'boolean' is not assignable to parameter of type 'Map<"valueOf", Map<never, never>> | Map<"valueOf", Map<never, never>> | List<any> | Map<never, never> | Map<never, never> | Map<never, never>'.
          .set('loading', false)
          .set('reportErrors', fromJS({}))
      );
    }
    case DELETE_RECURRING_EMAIL_SUCCESS: {
      // @ts-expect-error Property 'findIndex' does not exist on type 'Map<"valueOf", Map<never, never>> | Map<"valueOf", Map<never, never>> | List<any> | Map<never, never> | Map<never, never> | Map<never, never>'.
      const index = state.get('emailReports').findIndex((report) => report.get('id') === action.payload.id);

      // @ts-expect-error Argument of type 'any' is not assignable to parameter of type 'never'.
      return state.set('emailReports', state.get('emailReports').remove(index)).set('loading', false);
    }
    case CREATE_VIEW_FAIL:
    case UPDATE_VIEW_FAIL:
    case DELETE_VIEW_FAIL:
      return (
        state
          .set(
            'errors',
            // @ts-expect-error Argument of type 'Map<never, never> | { message: { translationId: string; }; }' is not assignable to parameter of type 'Map<"valueOf", Map<never, never>> | Map<"valueOf", Map<never, never>> | List<any> | Map<never, never> | Map<never, never> | Map<never, never>'.
            fromJS({
              message: {
                translationId: 'services.Views.error.updateActiveView',
              },
            })
          )
          // @ts-expect-error Argument of type 'boolean' is not assignable to parameter of type 'Map<"valueOf", Map<never, never>> | Map<"valueOf", Map<never, never>> | List<any> | Map<never, never> | Map<never, never> | Map<never, never>'.
          .set('loading', false)
      );
    case GET_RECURRING_EMAILS_FAIL:
      return (
        state
          .set('emailReports', fromJS([]))
          // @ts-expect-error Argument of type 'boolean' is not assignable to parameter of type 'Map<"valueOf", Map<never, never>> | Map<"valueOf", Map<never, never>> | List<any> | Map<never, never> | Map<never, never> | Map<never, never>'.
          .set('loading', false)
          // @ts-expect-error Argument of type 'Map<never, never> | { message: { translationId: string; }; }' is not assignable to parameter of type 'Map<"valueOf", Map<never, never>> | Map<"valueOf", Map<never, never>> | List<any> | Map<never, never> | Map<never, never> | Map<never, never>'.
          .set('errors', fromJS(getIn(action, ['payload', 'errors', 'data'])) || GENERIC_ERROR)
      );
    case CREATE_RECURRING_EMAIL_FAIL:
    case UPDATE_RECURRING_EMAIL_FAIL:
      return (
        state
          .set('reportErrors', fromJS(getIn(action, ['payload', 'errors', 'data']) || GENERIC_ERROR))
          // @ts-expect-error Argument of type 'boolean' is not assignable to parameter of type 'Map<"valueOf", Map<never, never>> | Map<"valueOf", Map<never, never>> | List<any> | Map<never, never> | Map<never, never> | Map<never, never>'.
          .set('loading', false)
      );
    case DELETE_RECURRING_EMAIL_FAIL:
      return (
        state
          // @ts-expect-error Argument of type 'boolean' is not assignable to parameter of type 'Map<"valueOf", Map<never, never>> | Map<"valueOf", Map<never, never>> | List<any> | Map<never, never> | Map<never, never> | Map<never, never>'.
          .set('loading', false)
          // @ts-expect-error Argument of type 'Map<never, never> | { message: { translationId: string; }; }' is not assignable to parameter of type 'Map<"valueOf", Map<never, never>> | Map<"valueOf", Map<never, never>> | List<any> | Map<never, never> | Map<never, never> | Map<never, never>'.
          .set('reportErrors', fromJS(getIn(action, ['payload', 'errors', 'data'])) || GENERIC_ERROR)
      );
    default:
      return state;
  }
}

export default viewsServiceReducer;
